
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.094 7.398c-.558.485-1.115.727-1.672.727-.797 0-1.276-.73-1.438-2.188h-.086C5.185 7.396 4.31 8.126 3.273 8.126c-.776 0-1.38-.32-1.812-.96-.432-.642-.649-1.556-.649-2.743 0-1.224.31-2.2.93-2.93.62-.729 1.37-1.094 2.25-1.094.656 0 1.17.157 1.54.47.374.312.697.835.968 1.57h.117L7.164.53h1.281v.383c-.375.578-.875 1.649-1.5 3.211.11 1.052.237 1.844.383 2.375.146.531.38.797.703.797.214 0 .466-.12.758-.36l.305.461zM5.859 4.227c-.14-1.172-.349-2-.625-2.485-.27-.484-.664-.726-1.18-.726-.551 0-.992.302-1.32.906-.328.599-.492 1.398-.492 2.398 0 1.922.477 2.883 1.43 2.883 1.015 0 1.745-.992 2.187-2.976z","fill":"currentColor"}})])
          )
        }
      }
    